/**
 * Menghitung jumlah kemunculan keyword dalam sebuah stream
 * @param stream - Konten artikel atau social media
 * @param keywords - Array keyword yang ingin dihitung
 * @param caseSensitive - Apakah perhitungan case sensitive (default: false)
 * @returns Array dengan format ["keyword:count", "keyword:count"]
 */
function countKeywordsInStream(
  stream: string,
  keywords: string[],
  caseSensitive: boolean = false
): string[] {
  const result: string[] = [];

  // Normalisasi stream jika tidak case sensitive
  const normalizedStream = caseSensitive ? stream : stream.toLowerCase();

  // Hitung setiap keyword
  keywords.forEach((keyword) => {
    if (!keyword.trim()) return; // Skip keyword kosong

    const normalizedKeyword = caseSensitive ? keyword : keyword.toLowerCase();

    // Escape special regex characters
    const escapedKeyword = normalizedKeyword.replace(
      /[.*+?^${}()|[\]\\]/g,
      '\\$&'
    );

    // Gunakan word boundary untuk menghitung kata utuh
    const regex = new RegExp(`\\b${escapedKeyword}\\b`, 'g');
    const matches = normalizedStream.match(regex);

    const count = matches ? matches.length : 0;
    result.push(`${keyword}:${count}`);
  });

  return result;
}

export default countKeywordsInStream;
